<template>
  <div>
    <drawer
      :title="addEditTitle"
      :dialogShow="addEditShow"
      @handleChange="handleChangeDrawer"
    >
      <div slot="body">
        <div class="pay-mains">
          <p class="order-title-boxs">
            <span class="blueBlock"></span><i>信息</i>
          </p>
          <div class="totals-box pl24 mt20">
            <div class="flex-row mb30">
              <div class="itemName">顾客姓名</div>
              <div class="itemNum">{{ customerName }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">领取方式</div>
              <template>
                <el-radio v-model="form.useStyle" label="use" @click="useAction">使用</el-radio>
                <el-radio v-model="form.useStyle" label="receive" @click="receiveAction">领取</el-radio>
              </template>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">寄存技师</div>
              <span class="jishi cur" @click="setStaff('item', 0)">{{staffIdNames ? staffIdNames : "请选择"}}></span>
              <!-- <el-select v-model="form.staffIds" class="width200">
                <el-option
                  v-for="(item, index) in staffList"
                  :key="index"
                  :label="item.staffName"
                  :value="item.id"
                ></el-option>
              </el-select> -->
            </div>
          </div>

          <div class="align-items">
            <p class="order-title-boxs">
              <span class="blueBlock"></span><i>产品</i>
            </p>
          </div>
          <div class="contents-body" v-if="availItemList.length != 0">
            <el-row class="tables-title" v-if="form.useStyle == 'receive'">
              <el-col :span="10" class="pl10">商品名称</el-col>
              <el-col :span="2">总数量</el-col>
              <el-col :span="6" style="text-align: center">领取数量</el-col>
              <el-col :span="6" style="text-align: center">领取类型</el-col>
            </el-row>
            <el-row class="tables-title" v-else>
              <el-col :span="18" class="pl10">商品名称</el-col>
              <el-col :span="6">总数量</el-col>
            </el-row>
            <div class="tables p30 scroll-auto">
              <div class="boxs" v-for="(item, index) in availItemList" :key="index">
                <el-row v-if="form.useStyle == 'receive'">
                  <div class="align-item">
                    <div class="mr10" @click="onClick(item,index)">
                      <img src="../../../assets/images/new/orderrefund_unchecked.png" alt="" v-if="item.count <= 0"/>
                      <img src="../../../assets/images/new/order_orderrefund_select.png" alt="" v-else-if="item.isSelected"/>
                      <img src="../../../assets/images/new/order_orderrefund_unchecked.png" alt="" v-else/>
                    </div>
                    <div class="w100b align-item">
                      <el-col
                        :span="10"
                        class="pl10"
                        :class="[item.itemNum == 0 ? 'color999' : '']"
                        >{{ item.itemName }}</el-col
                      >
                      <el-col :span="2" class="color999">{{
                        item.itemNum
                      }}</el-col>
                      <el-col :span="6" class="nums center pr10">
                        <span class="del-img" @click="blurItem('del', item)">
                          <img src="../../../assets/images/new/del.png" alt=""/>
                        </span>
                        <el-input
                          v-model="item.count"
                          readonly=""
                          size="mini"
                          style="width: 40px;"
                          :disabled="item.count == 0 ? true : false"
                        ></el-input>
                        <span class="del-img" @click="blurItem('add', item)">
                          <img src="../../../assets/images/new/add.png" alt=""/>
                        </span>
                      </el-col>
                      <el-col :span="6" class="color999">
                        <el-select v-model="item.drawType" class="width100">
                          <el-option
                            v-for="(item, index) in drawStyleList"
                            :key="index"
                            :label="item.value"
                            :value="item.code"
                          ></el-option>
                        </el-select>
                      </el-col>
                    </div>
                  </div>
                </el-row>

                <el-row v-else>
                  <div class="align-item">
                    <div class="mr10" @click="onClick(item,index)">
                      <img src="../../../assets/images/new/orderrefund_unchecked.png" alt="" v-if="item.count <= 0"/>
                      <img src="../../../assets/images/new/order_orderrefund_select.png" alt="" v-else-if="item.isSelected"/>
                      <img src="../../../assets/images/new/order_orderrefund_unchecked.png" alt="" v-else/>
                    </div>
                    <div class="w100b align-item">
                      <el-col
                        :span="18"
                        class="pl10"
                        :class="[item.itemNum == 0 ? 'color999' : '']"
                        >{{ item.itemName }}</el-col
                      >
                      <el-col :span="6" class="color999">{{
                        item.itemNum
                      }}</el-col>
                    </div>
                  </div>
                </el-row>
              </div>
              <div class="mb30" v-if="form.useStyle == 'receive'">
                <div class="mt20">签名照片</div>
                <div class="mt10">
                  <imgUploads
                    @file="getSignature"
                    :fileList="form.signUrl"
                    module="deposit"
                  ></imgUploads>
                </div>
              </div>
              <p class="order-title-boxs">
                <span class="blueBlock"></span><i>备注</i>
              </p>
              <div class="plr24 mb30">
                <el-input
                  type="textarea"
                  v-model="form.remark"
                  placeholder="请输入备注"
                  maxlength="150"
                  show-word-limit
                ></el-input>
              </div>
              <div class="paperIndex-info">
                <p class="tips-title infos">温馨提示</p>
                <div class="hint" v-for="(item, index) in tips" :key="index">
                  {{ item }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="drawer-footer">
          <div class="btns pr24 pb10" v-if="form.useStyle == 'receive'">
            <div class="flex-row">
              <p>
                领取数量：
                <span class="moneys">{{ totalNums }}</span>
              </p>
            </div>
            <el-button type="primary" class="small-btn" @click="commit"
              >提交</el-button>
          </div>
          <div class="btns pr24 pb10" v-else>
            <el-button type="primary" class="small-btn" @click="commit"
              >提交</el-button>
          </div>
        </div>
      </div>
    </drawer>
    <staff-set ref="staffSetForm" :isCashier="true" @staffChange="changePage"></staff-set>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import drawer from "../../../components/common/drawer";
import staffSet from "../../components/staff-set";
import imgUploads from "../../../components/common/modules/singleUpload";
import {decrypt,encrypt} from '../../../assets/javascript/untils';
export default {
  mixins: [minxin],
  components: { drawer, imgUploads, staffSet },
  data() {
    return {
      addEditTitle: "领取寄存产品",
      addEditShow: false,
      totalNums: 0,
      tips: [],
      radio: "receive",
      form: {
        depositId: "",
        useStyle: "receive",
        staffNames: "",
        staffIds: "",
        remark: "",
        signUrl: "",
        itemList: [],
      },
      customerName: "",
      depositId: "",

      staffList: [],
      availItemList: [],
      drawStyleList: [],

      staffIds: {},
      staffIdNames: "",
      fisrtName: [],
    };
  },
  created() {
    this.editInit();
  },
  methods: {
    back() {
      this.addEditShow = false;
    },
    editInit() {
      this.$on("set", function(org) {
        Object.assign(this.$data, this.$options.data());
        this.customerName = org.customerName;
        this.depositId = org.id;
        this.addEditShow = true;
        this.form.depositId = org.id;
        this.$api
          .get(this.$url.report.availItemList, {
            id: org.id,
          })
          .then((res) => {
            if (res) {
              this.availItemList = res;
              this.availItemList.map((item) => {
                this.$set(item, "count", item.leftNum ? item.leftNum : 1);
              });
            }
          });

        this.cardOldList();
        this.getDrawStyle();
        this.getTips();
      });
    },
    cardOldList() {
      this.$api
        .get(this.$url.companyStaff.list, {filterStatus: 'disable'})
        .then((res) => {
          if (res) {
            this.staffList = res;
          }
        })
        .catch((error) => {});
    },
    getDrawStyle() {
      this.$api.get(this.$url.report.getDrawStyle).then((res) => {
        if (res) {
          this.drawStyleList = res;
        }
      });
    },
    getTips() {
      this.$api
        .get(this.$url.companyRefund.getTips, { type: "deposit" })
        .then((res) => {
          if (res) {
            this.tips = res;
          }
        });
    },
    // setStaff(row, index) {
    //   this.$set(row, "drawStyleCn", true);
    //   this.staffIndex = index;
    //   this.$refs["staffSetForm"].$emit("set", {
    //     drawStyleCn: row.value,
    //     index: index,
    //   });
    // },

    setStaff(row, index) {
      this.$refs["staffSetForm"].$emit("set", {
        staffIds: this.fisrtName,
        index: index
      });
    },
    changePage(org) {
         // 选择技师 -- 回调
        if (org) {
            let id = [];
            let name = []
            console.log(org, '---------');
            this.fisrtName = org.staffIds;
            org.staffIds.map(item => {
                id.push(item.staffId);
                name.push(item.staffName)
            })

            id = id.join(",")
            name = name.join(",")
            this.staffIdNames = name;
            this.$set(this.staffIds, 'staffIds', id)
            this.form.staffIds = id;
            this.form.staffNames = name;
        }
    },

    useAction() {
      this.form.useStyle = "use";
      this.availItemList.map((item) => {
        item.isSelected = NO;
      });
    },
    receiveAction() {
      this.form.useStyle = "receive";
      this.availItemList.map((item) => {
        item.isSelected = NO;
      });
    },
    onClick(item,index) {
      item.isSelected = !item.isSelected;
      this.$set(this.availItemList, index, item);
      if (!item.isSelected && this.totalNums > 0) {
        this.totalNums -= item.count;
      } else {
        this.totalNums += item.count;
      }
    },
    blurItem(type, item) {
      console.log(item);
      if (type == "del") {
        if (item.count > 1) {
          item.count--;
          if (item.isSelected) {
            this.totalNums--;
          }
        }
      } else {
        if (item.count >= item.leftNum) return;
        item.count++;
        if (item.isSelected) {
          this.totalNums++;
        }
      }
    },
    handleChangeDrawer() {
      this.addEditShow = false;
      this.$emit("change", false);
    },
    getSignature(res) {
      // 签名照片
      this.form.signUrl = res;
      console.log(res);
    },

    commit() {
      if (this.form.useStyle == "receive") {
        if (!this.form.staffIds) {
          return this.$message.error("请选择寄存技师");
        } else if (this.totalNums == 0) {
          return this.$message.error("请选择产品");
        }
        for (let i = 0; i < this.availItemList.length; i++) {
          if (this.availItemList[i].isSelected) {
            if (!this.availItemList[i].drawType) {
              return this.$message.error("请选择领取类型");
            }
          }
        }
        if (!this.form.remark) {
          return this.$message.error("请输入备注");
        }
      } else {
        if (!this.form.staffIds) {
          return this.$message.error("请选择寄存技师");
        }
        let selectArray = [];
        this.availItemList.map((item) => {
          if (item.isSelected) {
            selectArray.push(item);
          }
        });
        if (selectArray.length == 0) {
          return this.$message.error("请选择产品");
        }
        if (!this.form.remark) {
          return this.$message.error("请输入备注");
        }
      }

      if (!this.form.signUrl && this.form.useStyle == "receive") {
        return this.$message.error("请上传签名图片");
      }
      this.staffList.map((item) => {
        if (this.form.staffIds == item.id) {
          this.form.staffNames = item.staffName;
        }
      });

      let uploadItemArray = [];
      if (this.form.useStyle == "receive") {
        this.availItemList.map((item) => {
          if (item.isSelected) {
            let form = {
              itemId: item.itemId,
              itemNum: item.count,
              itemName: item.itemName,
              drawType: item.drawType,
            };
            uploadItemArray.push(form);
          }
        });
      }else {
        this.availItemList.map((item) => {
          if (item.isSelected) {
            let form = {
              itemId: item.itemId,
              itemNum: item.leftNum,
              itemName: item.itemName,
              drawType: "",
            };
            uploadItemArray.push(form);
          }
        });
      }

      this.form.itemList = uploadItemArray;
      let arr = encrypt(JSON.stringify(this.form));
      this.$api
        .post(this.$url.report.depositTakeInfoSave, arr)
        .then((res) => {
          if (res) {
            console.log(this.depositId, '3333   ');
            this.addEditShow = false;
            this.$message.success("提交成功");
            this.$emit("receiveProductChange", true);
            this.$refs["member"].clearMember();
          }
        })
        .catch((error) => {});
    },
  },
};
</script>

<style scoped lang="less">
@import "../../../assets/css/edit.less";
.contents-body {
  .center {
    text-align: center;
  }
  .right {
    text-align: right;
  }
  .tables-title {
    font-size: 14px;
    margin: 0 16px;
    padding: 10px 0;
    font-size: 16px;
    font-weight: 600;
    background: #f7f8fa;
  }
  .tables {
    padding: 0 16px 0;
    max-height: 150px;
    box-sizing: border-box;
    .boxs {
      min-height: 65px;
      padding: 24px 0;
      box-sizing: border-box;
      border-bottom: 1px solid #ebedf0;
      .titles {
        font-weight: 500;
      }
      .money {
        color: @money;
        font-weight: 500;
      }

      .delete {
        font-size: 18px;
        cursor: pointer;
        &:hover {
          color: @blue;
        }
      }
    }
    .right-content {
      margin-top: 20px;
      display: flex;
      justify-content: space-between;
      .staff-btn {
        display: inline-block;
        text-align: center;
        color: #111;
      }
    }
  }
}
.memberInfo {
  padding: 0 20px;
}
.pay-mains {
  padding: 0;
  overflow: hidden;
}
.nums {
  display: flex;
  justify-content: center;
  .del-img {
    width: 28px;
    height: 28px;
    cursor: pointer;
    img {
      width: 100%;
      height: 100%;
    }
  }
  /deep/ .el-input__inner {
    border-radius: inherit;
    text-align: center;
    padding: 0;
    border-left: none;
    border-right: none;
  }
}

.paperIndex-info {
  width: calc(100% - 90px);
  margin: 0 24px;
  font-size: 16px;
  background: #fbfbfc;
  border: 1px solid #e5e5e5;
  border-radius: 4px;
  color: #666;
  padding: 20px;
}

.tips-title {
  margin-bottom: 10px;
}
.infos {
  color: #111;
}

.tips {
  position: absolute;
  bottom: 80px;
  padding: 10px 20px;
  .tips-title {
    margin-bottom: 10px;
  }
  .infos {
    color: #111;
  }
  .hint {
    font-size: 16px;
    color: #666;
    line-height: 26px;
  }
}
.btns {
  display: flex;
  align-items: center;
  p {
    margin-right: 30px;
  }
}

</style>
